import * as React from 'react';
import StepTypeField from './StepTypeField';
import { NumberField, TextArea } from './forms';
import { StepType, GuideStep } from '../guide';

const defaultInstruction = (step: GuideStep): string => {
  const amount = step.amount;
  const unit = step.amount_unit;
  const duration = step.time_duration;

  switch (step.type) {
    case StepType.grind:
      return `Grind ${amount}${unit} of coffee`;
    case StepType.boil:
      return `Boil ${amount}ml of water`;
    case StepType.prepare:
      return `Prepare the following`;
    case StepType.wait:
      return `Wait for ${duration} seconds`;
    case StepType.stir:
      return `Stir for ${duration} seconds`;
    case StepType.pour:
      return `Pour ${amount}${unit} of water`;
    case StepType.bloom:
      return `Pour ${amount}${unit} of water and wait to bloom`;
  }
};

const withNewInstruction = (step: GuideStep): GuideStep =>
  Object.assign({}, step, {
    name: defaultInstruction(step),
  });

const amountVisible = (type: StepType): boolean => {
  return type === StepType.bloom || type === StepType.pour;
};

const setValue = (obj: any, index: number, onChange: Function) => (
  field: string,
  newValue: String,
) =>
  onChange(
    withNewInstruction(
      Object.assign({}, obj, {
        [field]: newValue,
      }),
    ),
  );

type Props = {
  canAddBloomStep: boolean;
  canAddPourStep: boolean;
  index: number;
  onChange: Function;
  onDelete: Function;
  step: GuideStep;
};

export default function GuideStepEditForm(props: Props) {
  const [step, setStep] = React.useState(props.step);

  return (
    <div className="flex-ns flex-column">
      <div className="flex-ns items-center">
        <div className="w-100 w-50-ns pr3 w-50">
          <StepTypeField
            field={['type']}
            value={step.type}
            onChange={setValue(step, props.index, setStep)}
            canAddBloomStep={props.canAddBloomStep}
            canAddPourStep={props.canAddPourStep}
          />
        </div>
        <div className="w-100 w-50-ns pr3">
          <p className="black b">{defaultInstruction(step)}</p>
          <div className={amountVisible(step.type) ? 'db' : 'dn'}>
            <NumberField
              label="Amount (Grams)"
              field={['amount']}
              id="amount"
              defaultValue={`${step.amount}`}
              onValueChange={setValue(step, props.index, setStep)}
            />
          </div>
          <NumberField
            label="Duration (seconds)"
            field={['time_duration']}
            id="time_duration"
            defaultValue={`${step.time_duration}`}
            onValueChange={setValue(step, props.index, setStep)}
          />
          <TextArea
            label="Description"
            field={['description_text']}
            id="description_text"
            defaultValue={step.description_text}
            onValueChange={setValue(step, props.index, setStep)}
          />
        </div>
      </div>
      <div className="flex pa3 justify-center">
        <button
          type="button"
          className="ma4 tc red b db link bg-transparent bw0 pointer"
          onClick={() => props.onDelete(step)}
        >
          Delete
        </button>
        <button
          type="button"
          className="ma4 tc black b underline db link bg-transparent bw0 pointer"
          onClick={() => props.onChange(props.index, withNewInstruction(step))}
        >
          Done
        </button>
      </div>
    </div>
  );
}
